import ConfirmModal from 'features/app/components/ConfirmModal';
import { dialog } from 'features/app/utils/dialog';
import { t } from 'locales/i18n';

interface ConfirmDialogOptions {
  confirmText?: string;
  rejectText?: string;
  title?: string;
}

export const confirmDialog = ({ confirmText = t('yes'), rejectText = t('no'), title }: ConfirmDialogOptions) => {
  return dialog(({ giveAnswer }) => (
    <ConfirmModal
      open={true}
      onClose={giveAnswer.bind(this, undefined)}
      title={title}
      primaryButtonText={confirmText}
      secondaryButtonText={rejectText}
      onPrimaryClick={giveAnswer.bind(this, true)}
      onSecondaryClick={giveAnswer.bind(this, false)}
    />
  )) as Promise<boolean | undefined>;
};
